import { DataGridCellParams } from "@components/common/data-grid/adm-data-grid-types";

/** A row entity in the testing impersonation table */
export type TestingImpersonationTableEntity = {
  /** The id of the member used to generate the login access link */
  memberId: string;

  /** The name of the member */
  name: string;

  /** The email of the member */
  email: string;

  /** A description of the entry */
  description: string;
};

/** The column definition for the testing impersonation table with the field property typed */
export type TestingImpersonationTableGridColDef = DataGridCellParams<
  TestingImpersonationTableEntity,
  TestingImpersonationTableColumnField
>;

/** The column fields that can be used in the testing impersonation table */
export type TestingImpersonationTableColumnField =
  "nameAndEmail" | "description" | "loginLink";

/** The labels for the columns in the testing impersonation table */
export const TESTING_IMPERSONATION_TABLE_COLUMN_LABELS: Record<
  TestingImpersonationTableColumnField,
  string
> = {
  nameAndEmail: "Name and email",
  description: "Description",
  loginLink: "Login link",
};
